import { gql, useApolloClient, useReactiveVar } from "@apollo/client";
import { v4 as uuid } from "uuid";
import { useRollbar } from '@rollbar/react';
import { currentShopifyVersionVar } from "../helpers/client";
import { AddVariantFragmentDoc, SubscriptionBenefitProductFragmentDoc, } from "../types";
export const useUpdateSubscriptionBenefitProduct = (productId, field, defaultValue) => {
    const rollbar = useRollbar();
    const client = useApolloClient();
    const onClick = (ev) => {
        const product = client.readFragment({
            id: `Product:${productId}`,
            fragment: SubscriptionBenefitProductFragmentDoc,
            fragmentName: "SubscriptionBenefitProduct",
        });
        if (!product)
            return;
        let value;
        try {
            switch (field) {
                case "curationValue":
                    value = parseFloat(ev === null || ev === void 0 ? void 0 : ev.target.value);
                    if (isNaN(value))
                        value = defaultValue;
                    break;
                case "curationExcludeProducts":
                    //@ts-ignore
                    value = ev === null || ev === void 0 ? void 0 : ev.map(eachValue => eachValue.value.split(",")[0].split("/").pop());
                    break;
                case "curationCollections":
                    //@ts-ignore
                    value = ev === null || ev === void 0 ? void 0 : ev.map(eachValue => eachValue.value);
                    break;
                default:
                    value = (ev === null || ev === void 0 ? void 0 : ev.target.value) ? ev === null || ev === void 0 ? void 0 : ev.target.value : defaultValue;
            }
            client.writeFragment({
                id: `Product:${productId}`,
                fragment: SubscriptionBenefitProductFragmentDoc,
                fragmentName: "SubscriptionBenefitProduct",
                data: Object.assign(Object.assign({}, product), { [field]: value })
            });
        }
        catch (e) {
            console.log("Error updating subscription benefit product:" + field, e, ev);
            rollbar.error("Error updating subscription benefit product:" + field, e, ev);
        }
    };
    const onBlur = (ev) => {
        // mixpanel.track("Subscription Box", {
        //   action: "Edited Subscription Benefit Product",
        //   field: field,
        //   value: ev.target.value,
        // })
    };
    return [onClick, onBlur];
};
gql `
fragment AddVariant on Variant {
  id
  description
  additionalCost {
    amount
  }
  platformName
  platformId
  curationExcludeProducts
  curationIncludeVariants
  curationSearchTerms
  curationStatus
  curationError
  flagReason
}
`;
export const useAddVariant = ({ productId }) => {
    const client = useApolloClient();
    const currentShopifyVersion = useReactiveVar(currentShopifyVersionVar);
    return () => {
        // mixpanel.track("Subscription Box", {
        //   action: "Added Variant",
        // })
        const newVariant = {
            id: uuid(),
            __typename: "Variant",
            description: "",
            additionalCost: {
                amount: 0,
            },
            // KGAUDIT - this probably shound't be shopify unless it is.
            platformName: currentShopifyVersion == 2 ? "shopify" : "",
            platformId: "",
            curationExcludeProducts: [],
            curationIncludeVariants: [],
            curationSearchTerms: "",
            curationStatus: "APPROVED",
            curationError: null,
            flagReason: null,
        };
        client.cache.modify({
            id: `Product:${productId}`,
            fields: {
                variants(existingVariantRefs = [], { readField }) {
                    if (!existingVariantRefs) {
                        existingVariantRefs = [];
                    }
                    const newVariantRef = client.cache.writeFragment({
                        fragment: AddVariantFragmentDoc,
                        data: newVariant,
                    });
                    if (existingVariantRefs.some((ref) => readField("id", ref) === newVariant.id)) {
                        return existingVariantRefs;
                    }
                    return [...existingVariantRefs, newVariantRef];
                },
            },
        });
    };
};
export const useRemoveProduct = ({ benefitId, productId, benefitKind }) => {
    const client = useApolloClient();
    return () => {
        // mixpanel.track("Subscription Box", {
        //   action: "Removed Product",
        // })
        client.cache.modify({
            id: `${benefitKind}:${benefitId}`,
            fields: {
                products(existingProductRefs = [], { readField }) {
                    return existingProductRefs.filter(ref => readField('id', ref) !== productId);
                },
            },
        });
    };
};
